import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './OccupancyPermissionCertificate.css';
import logo from "../../../../../assets/image/ipdc logo.png";
import star from "../../../../../assets/image/star.png";
import Button from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';
import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
import html2pdf from 'html2pdf.js'; // Import html2pdf

const OccupancyPermissionCertificate = () => {
  const location = useLocation();
  const permitData = location.state?.permitData || {};
  const printRef = useRef();
  const [coordinateData, setCoordinateData] = useState([
    { x: '722713.4793', y: '1307200.8227' },
    { x: '722716.9428', y: '1307201.3268' },
    { x: '722716.4388', y: '1307204.7902' },
    { x: '722827.5631', y: '1307220.9624' },
    { x: '722839.3137', y: '1307140.2197' },
    { x: '722724.6372', y: '1307124.1532' }
  ]);
  const [permitDrawing, setPermitDrawing] = useState({ x: '722713.4793', y: '1307200.8227' },
    { x: '722716.9428', y: '1307201.3268' },
    { x: '722716.4388', y: '1307204.7902' },
    { x: '722827.5631', y: '1307220.9624' },
    { x: '722839.3137', y: '1307140.2197' },
    { x: '722724.6372', y: '1307124.1532' });
  var permitdrawing1, permitdrawing2;
  const [formData, setFormData] = useState({
    // Format dates
    date: new Date().toLocaleDateString(),
    serialNo: permitData.id || '',

    // Industry Park info (you may need to fetch these)
    nameOfIndustryPark: permitData.park_name, // To be filled from other data
    owner: 'Industrial Parks Development Corporation', // Default
    lesseesName: '', // To be filled from agreement
    sizeOfPlot: permitData.parcel_size ? `${permitData.parcel_size}` : '',
    titleDeedNo: '', // To be filled from agreement/parcel
    addressCity: permitData.city, // To be filled from parcel

    // Permit details
    buildingPermitNo: permitData.buildingpermitno || '',
    permitIssueDate: permitData.issued_on ? new Date(permitData.issued_on).toLocaleDateString() : '',
    permitExpiryDate: permitData.expire ? new Date(permitData.expire).toLocaleDateString() : '',

    // Drawings status
    drawings: {
      architectural: true,
      structural: true,
      electrical: true,
      sanitary: true,
      electromechanical: false,
      telecom: false
    },
   
    // Coordinates (same as before)
    coordinates: coordinateData,

    // Signatures
    approvedBy: permitData.permit_issued_by || '',
    checkedBy: permitData.permit_registered_by || '',
    certifiedBy: 'Habtamu'
  });
  console.log("DATAAAAAAAAA",permitData)

  // Just update data when permitData changes
  useEffect(() => {
    //  #########################
    // const fetchAllData = async () => {
    //   try {
    //     // Fetch building permit Data
    //     const allbuildingpermit = await GetDataFromApiWithParams(`buildingpermits/bulidingwithid/${permitData.agreement_id}`);
    //     permitdrawing1 = await GetDataFromApiWithParams("/buildingPermits");
    //     setPermitDrawing(permitdrawing1)
    //     const permitdrawing2 = permitdrawing1.find(item => item.agreement_id === permitData.agreement_id);
    //     setPermitDrawing(permitdrawing2)

    //     const originalData = allbuildingpermit[0].coordinates;
    //     const distinctCoordinates = originalData.filter((obj, index, self) =>
    //       index === self.findIndex(item =>
    //         item.x === obj.x && item.y === obj.y
    //       )
    //     );

    //     const result = [
    //       distinctCoordinates[0],
    //       distinctCoordinates[Math.floor(distinctCoordinates.length / 4)],
    //       distinctCoordinates[Math.floor(distinctCoordinates.length / 2)],
    //       distinctCoordinates[Math.floor(3 * distinctCoordinates.length / 4)],
    //       distinctCoordinates[distinctCoordinates.length - 1]
    //     ].filter((coord, index, self) =>
    //       index === self.findIndex(c => c.x === coord.x && c.y === coord.y)
    //     );

    //     setCoordinateData(result)
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // };
    //******************************************************************************************* */
    const fetchAllData = async () => {
      try {
        // Fetch building permit Data
        const allbuildingpermit = await GetDataFromApiWithParams(`buildingpermits/bulidingwithid/${permitData.agreement_id}`);
        
        // Fetch agreement data to get company name
        const agreementData = await GetDataFromApiWithParams(`agreements/${permitData.agreement_id}`);
        console.log("Agreement Data:", agreementData);
        
        // Extract company name from agreement data
        let companyName = '';
        if (agreementData && agreementData.length > 0) {
          // The agreement data comes from getAgreementById which returns an array
          const agreement = agreementData[0];
          companyName = agreement?.company_name || 
                        agreement?.company || 
                        agreement?.investor_company_name || 
                        agreement?.tenant_company_name ||
                        '';
          console.log("Company Name:", companyName);
        }
        
        // Update formData with company name
        setFormData(prev => ({
          ...prev,
          lesseesName: companyName || prev.lesseesName || 'IPDC'
        }));
        
        permitdrawing1 = await GetDataFromApiWithParams("/buildingPermits");
        setPermitDrawing(permitdrawing1)
        const permitdrawing2 = permitdrawing1.find(item => item.agreement_id === permitData.agreement_id);
        setPermitDrawing(permitdrawing2)
    
        const originalData = allbuildingpermit[0].coordinates;
        const distinctCoordinates = originalData.filter((obj, index, self) =>
          index === self.findIndex(item =>
            item.x === obj.x && item.y === obj.y
          )
        );
    
        const result = [
          distinctCoordinates[0],
          distinctCoordinates[Math.floor(distinctCoordinates.length / 4)],
          distinctCoordinates[Math.floor(distinctCoordinates.length / 2)],
          distinctCoordinates[Math.floor(3 * distinctCoordinates.length / 4)],
          distinctCoordinates[distinctCoordinates.length - 1]
        ].filter((coord, index, self) =>
          index === self.findIndex(c => c.x === coord.x && c.y === coord.y)
        );
    
        setCoordinateData(result)
      } catch (error) {
        console.error("Error fetching data:", error);
        // If error, keep existing lesseesName or use IPDC as fallback
        setFormData(prev => ({
          ...prev,
          lesseesName: prev.lesseesName || 'IPDC'
        }));
      }
    };
    if (permitData.agreement_id) {
      fetchAllData();
    }
    
    if (permitData) {
      setFormData(prev => ({
        ...prev,
        serialNo: permitData.id || prev.serialNo,
        buildingPermitNo: permitData.permit_no || prev.buildingPermitNo,
        sizeOfPlot: permitData.parcel_size ? `${permitData.parcel_size}` : prev.sizeOfPlot,
        permitIssueDate: permitData.issued_on ? new Date(permitData.issued_on).toLocaleDateString() : prev.permitIssueDate,
        permitExpiryDate: permitData.expected_finishing_date ? new Date(permitData.expected_finishing_date).toLocaleDateString() : prev.permitExpiryDate,
        approvedBy: permitData.permit_issued_by || prev.approvedBy,
        checkedBy: permitData.permit_registered_by || prev.checkedBy
      }));
    }
  }, [permitData]);

  // PRINT FUNCTION - Opens in new window with proper scaling
  const handlePrint = () => {
    const printContent = printRef.current;
    
    // Create a new window for printing
    const printWindow = window.open('', '_blank', 'width=1200,height=900');
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Building Permit Certificate - ${formData.buildingPermitNo}</title>
        <style>
          /* Reset all styles and apply scaling */
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: 'Times New Roman', Times, serif;
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            transform: scale(0.75);
            transform-origin: top left;
            position: absolute;
            top: 0;
            left: 0;
          }
          
          /* Import your certificate CSS */
          ${document.querySelector('style')?.innerHTML || ''}
          
          /* Force all elements to maintain their layout */
          .certificate-container {
            width: 133% !important; /* Compensate for scaling */
            height: auto !important;
            position: relative !important;
            margin: 0 !important;
            padding: 0 !important;
            display: block !important;
          }
          
          /* Ensure two-column layout stays */
          .two-column-layout {
            display: flex !important;
            width: 100% !important;
            flex-direction: row !important;
          }
          
          .column {
            display: block !important;
            float: none !important;
            position: relative !important;
          }
          
          /* Force tables to stay inline */
          table {
            display: table !important;
            width: 100% !important;
          }
          
          tr {
            display: table-row !important;
          }
          
          td, th {
            display: table-cell !important;
          }
          
          /* Hide print buttons */
          .no-print {
            display: none !important;
          }
          
          @media print {
            @page {
              size: A4 landscape;
              margin: 0mm;
            }
            
            body {
              transform: scale(0.72) !important;
              transform-origin: top left !important;
              width: 138% !important;
              height: auto !important;
            }
            
            html, body {
              width: 100% !important;
              height: 100% !important;
              overflow: hidden !important;
            }
            
            .certificate-container {
              width: 100% !important;
              max-width: none !important;
              page-break-inside: avoid !important;
            }
            
            /* Prevent page breaks */
            .two-column-layout,
            .certificate-body,
            .signatures-section {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }
            
            /* Scale down fonts further for print */
            body {
              font-size: 10px !important;
            }
            
            h1.certificate-title {
              font-size: 14px !important;
              line-height: 1.2 !important;
              margin: 5px 0 !important;
            }
            
            table {
              font-size: 8px !important;
            }
            
            .coordinates-table td,
            .drawings-table td {
              padding: 1px 2px !important;
              font-size: 7px !important;
            }
            
            .signature-line {
              font-size: 9px !important;
            }
          }
        </style>
      </head>
      <body>
        ${printContent.innerHTML}
      </body>
      </html>
    `);
    
    printWindow.document.close();
    
    // Wait a moment for styles to apply, then print
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  // Alternative: Direct print with aggressive scaling

const handleDirectPrint = () => {
  // Create a new window with exact dimensions
  const printWindow = window.open('', '_blank', 'width=1200,height=900');
  
  // Get ALL CSS from the current page
  let allCSS = '';
  const styleSheets = document.styleSheets;
  
  for (let i = 0; i < styleSheets.length; i++) {
    try {
      const rules = styleSheets[i].cssRules || styleSheets[i].rules;
      if (rules) {
        for (let j = 0; j < rules.length; j++) {
          allCSS += rules[j].cssText + '\n';
        }
      }
    } catch (e) {
      // Skip cross-origin stylesheets
    }
  }
  
  // Get inline styles
  const inlineStyles = Array.from(document.querySelectorAll('style'))
    .map(style => style.innerHTML)
    .join('\n');
  
  // Get the certificate HTML
  const certificateHTML = printRef.current.outerHTML;
  
  // Create the print document
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Building Permit Certificate</title>
      <meta charset="UTF-8">
      <style>
        /* Import all original styles */
        ${allCSS}
        ${inlineStyles}
        
        /* Reset for print window */
        body, html {
          margin: 0 !important;
          padding: 0 !important;
          width: 100% !important;
          height: 100% !important;
          background: #f5f5f5 !important;
          overflow: auto !important;
        }
        
        /* Container to center the certificate */
        .print-wrapper {
          width: 100%;
          min-height: 100vh;
          padding: 20px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          box-sizing: border-box;
        }
        
        /* Hide print buttons in the certificate */
        .no-print {
          display: none !important;
        }
        
        /* Print-specific styles */
        @media print {
          @page {
            size: A4 landscape;
            margin: 15mm;
          }
          
          body, html {
            background: white !important;
            padding: 0 !important;
            margin: 0 !important;
          }
          
          .print-wrapper {
            padding: 0 !important;
            display: block !important;
            width: 100% !important;
            height: auto !important;
            min-height: auto !important;
          }
          
          .certificate-container {
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            transform: none !important;
            page-break-inside: avoid !important;
          }
          
          /* Prevent splitting across pages */
          .two-column-layout,
          .signatures-section,
          .certificate-body {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-wrapper">
        ${certificateHTML}
      </div>
    </body>
    </html>
  `);
  
  printWindow.document.close();
  
  // Wait a bit for styles to load, then trigger print
  setTimeout(() => {
    printWindow.focus();
    
    // Check if content fits on one page
    setTimeout(() => {
      printWindow.print();
    }, 300);
  }, 500);
};
  // Save as PDF function
  const handleSaveAsPDF = async () => {
    const element = printRef.current;
    
    try {
      // Create a temporary div with print styles
      const tempDiv = document.createElement('div');
      tempDiv.style.cssText = `
        position: absolute;
        left: -9999px;
        top: 0;
        width: 1200px;
        transform: scale(0.7);
        transform-origin: top left;
      `;
      
      // Clone the certificate content
      const clone = element.cloneNode(true);
      tempDiv.appendChild(clone);
      document.body.appendChild(tempDiv);
      
      // PDF options
      const opt = {
        margin: 0,
        filename: `Building_Permit_${formData.buildingPermitNo || 'Certificate'}.pdf`,
        image: { 
          type: 'jpeg', 
          quality: 0.98 
        },
        html2canvas: { 
          scale: 2,
          useCORS: true,
          width: 1200,
          height: 800,
          scrollX: 0,
          scrollY: 0,
          windowWidth: 1200
        },
        jsPDF: { 
          unit: 'mm', 
          format: 'a4', 
          orientation: 'landscape',
          compress: true
        }
      };
      
      // Generate PDF
      await html2pdf().set(opt).from(tempDiv).save();
      
      // Clean up
      document.body.removeChild(tempDiv);
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Using print instead.');
      handleDirectPrint();
    }
  };

  // Alternative simpler PDF generation
  const handleSimplePDF = () => {
    const element = printRef.current;
    
    const opt = {
      margin: 0.5,
      filename: `Building_Permit_${formData.buildingPermitNo || 'Certificate'}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
        scale: 2,
        useCORS: true,
        width: 1123, // A4 width in pixels at 96 DPI
        height: 794, // A4 height in pixels at 96 DPI
        windowWidth: 1123
      },
      jsPDF: { 
        unit: 'mm', 
        format: 'a4', 
        orientation: 'landscape',
        compress: true
      }
    };
    
    html2pdf().set(opt).from(element).save();
  };

  return (
    <div style={{ padding: '20px' }}>
      {/* PRINT BUTTONS - Will not appear in print */}
      <div className="no-print" style={{
        marginBottom: '0px',
        display: 'flex',
        gap: '10px',
        justifyContent: 'flex-end',
        padding: '10px',
        borderRadius: '5px'
      }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<PrintIcon />}
          onClick={handleDirectPrint}
          sx={{ backgroundColor: '#1976d2' }}
        >
          Print Certificate 
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          startIcon={<DownloadIcon />}
          onClick={handleSimplePDF}
          sx={{ marginLeft: '10px' }}
        >
          Save as PDF
        </Button>
      </div>

      {/* CERTIFICATE CONTENT - This will be printed */}
      <div ref={printRef} className="certificate-container">
        {/* The rest of your certificate JSX remains exactly the same */}
        <div className="certificate-header">
          <div className="header-top">
            <div className="left-logo">
              <div className="logo-container">
                <img
                  src={star}
                  alt="Star Logo"
                  className="logo-star"
                />
              </div>
            </div>

            <div className="right-logo">
              <div className="logo-container">
                <img
                  src={logo}
                  alt="ipdc Logo"
                  className="logo-star"
                />
              </div>
            </div>
          </div>
          <div className="header-bottom">
            <div>Date: {formData.date || '________________'}</div>
            <div>Serial No.: {formData.serialNo || '________________'}</div>
          </div>
          <h1 className="certificate-title">
            THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA<br />
            INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC) <br />
            <div>
              <span style={{ color: 'red', textDecoration: 'underline' }}>PERMANENT BUILDING OCCUPANCY PERMISSION CERTIFICATE</span>
            </div>
          </h1>
        </div>

        <div className="certificate-body">
          <div className="two-column-layout">
            {/* LEFT COLUMN */}
            <div className="column left-column">
              <div className="permit-details">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '160px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                      }}>
                        <span className="heading"> Name of Industry Park: </span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {console.log("soloooooo",formData)}

                          {formData.nameOfIndustryPark || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '25px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '2px',
                        color: '#2c3e50',
                        fontSize: '14px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading">Owner</span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.owner || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading"> Lessee's Name: </span>
                      </td>
                      <td style={{ verticalAlign: 'left' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.lesseesName || 'IPDC'}
                        </div>
                      </td>
                    </tr>

                   <tr style={{ height: '25px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '2px',
                        color: '#2c3e50',
                        fontSize: '14px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading">Title deed's No:</span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.titleDeedNo || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading"> Address, City: </span>
                      </td>
                      <td style={{ verticalAlign: 'left' }}>
                        <div style={{
                          width: '250px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.addressCity || '________________'}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={{ fontFamily: "'Times New Roman', Times, serif", fontSize: "12px", color:"black" }}>
                After checking the document presented and conducted Site Inspection the permanent occupancy permit for 3 Dormitory Blocks are:
                <span className="permitted"> PERMITTED</span>
              </div>

              <div className="permit-details">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                      }}>
                        <span className="heading"> Building Permit No.: </span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '200px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.buildingPermitNo || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '25px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '2px',
                        color: '#2c3e50',
                        fontSize: '14px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading">Permit Issue Date:</span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{
                          width: '200px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.permitIssueDate || '________________'}
                        </div>
                      </td>
                    </tr>

                    <tr style={{ height: '15px' }}>
                      <td style={{
                        width: '140px',
                        paddingRight: '20px',
                        color: '#2c3e50',
                        fontSize: '11px',
                        verticalAlign: 'middle'
                      }}>
                        <span className="heading"> Permit Expiry Date: </span>
                      </td>
                      <td style={{ verticalAlign: 'left' }}>
                        <div style={{
                          width: '200px',
                          height: '25px',
                          border: '1px solid #000',
                          padding: '0 15px',
                          display: 'flex',
                          fontSize: '11px',
                          fontFamily: "'Times New Roman', serif"
                        }}>
                          {formData.permitExpiryDate || '________________'}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="notice-section">
                <h3>Notice:</h3>
                <ol className="notice-list">
                  <li>This certificate is produced in five copies, one for the company, one for IPDC file, one for O&M DCEO one for the Design Department and one for IP branch office.</li>
                  <li>This certificate is valid with an approved A-1 paper size site plan with an authorized IPDC sign and seal.</li>
                  <li>This certificate will be canceled if the building is utilized for another purpose.</li>
                  <li>This certificate will be valid for 18 months starting from the date of issuance of this certificate.</li>
                </ol>
              </div>
            </div>

            {/* GREEN VERTICAL DIVIDER LINE */}
            <div className="vertical-divider"></div>

            {/* RIGHT COLUMN */}
            <div className="column right-column">
              

              <span className="heading"> Relevant Approved Documents attached : </span>
              <table className="drawings-table">
                <thead>
                  <tr className="table-row">
                    <td>Item no</td>
                    <td>Drawings</td>
                    <td></td>
                    <td>Remark</td>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { id: 1, name: 'plan_archtectural_path', label: 'Architectural' },
                    { id: 2, name: 'plan_structural_path', label: 'Structural' },
                    { id: 3, name: 'plan_electrical_path', label: 'Electrical' },
                    { id: 4, name: 'plan_sanitary_path', label: 'Sanitary' },
                    { id: 5, name: 'plan_electro_mechanical_path', label: 'Electromechanical' },
                    { id: 6, name: 'plan_environmental_path', label: 'Environmental' },
                    { id: 7, name: 'plan_other_path', label: 'Other Plans' },
                    { id: 8, name: 'telecom', label: 'Telecom' }
                  ].map((item) => {
                    const drawingValue = permitDrawing?.[item.name];
                    const hasDrawing = drawingValue && drawingValue.trim() !== '';

                    return (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.label}</td>
                        <td>
                          {hasDrawing ? '✓' : ''}
                        </td>
                        <td>
                          {hasDrawing ? 'Submitted' :
                            permitdrawing2 ? 'Pending' : 'Not Submitted'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div className="conditions-section">
                <ol className="conditions-list">
                  <li>Permitted as per the consultant, client & contractor commitment form signature</li>
                  <li>The construction has to be carried out with the approved Drawings only.</li>
                  <li>A major design amendment has to be submitted and get approval at the head office level.</li>
                </ol>
              </div>

              <div className="decision-section">
                <h3>Decision for Permission - <fa>factory Sheds and auxiliary building. </fa></h3>
              </div>

              <div className="coordinates-section">
               <span className="coordinate">Compound Location Coordinates</span> 
                <table className="coordinates-table">
                  {/* <thead> */}
                    <tr>
                      <td>X</td>
                      <td>Y</td>
                    </tr>
                  {/* </thead> */}
                  <tbody>
                    {coordinateData.map((coord, index) => (
                      <tr key={index}>
                        <td>{coord.x}</td>
                        <td>{coord.y}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="authority-section">
                <p className="authority-text">
                  This Building Permission Certificate is given to the above stated company by the IPDC as per the delegation of Authority from Ethiopian Investment Commission (EIC) in Mar, 04, 2016, concerning Issuance of construction and / or occupancy Permits.
                </p>
              </div>
        <div className="signatures-section">
          <div className="signature-row">
            <div className="signature-column">
              <div className="signature-label">Prepard by:</div>
              <div className="signature-line">_________________________</div>
              <div style={{ fontSize: '11px', marginTop: '5px' }}>{formData.certifiedBy}</div>
            </div>

            <div className="signature-column">
              <div className="signature-label">Issued by:</div>
              <div className="signature-line">_________________________</div>
              <div style={{ fontSize: '11px', marginTop: '5px' }}>{}</div>
            </div>

            <div className="signature-column">
              <div className="signature-label">Approved by:</div>
              <div className="signature-line">_________________________</div>
              <div style={{ fontSize: '11px', marginTop: '5px' }}>{}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OccupancyPermissionCertificate;